<template>
  <div class="footer">
    <div class="container">
      <div class="w-100 mb-50">
        <img src="../assets/social-doctor-logo.svg" alt="" />
      </div>
      <div class="w-100 mb-70">
        <strong class="mb-12">{{ $t('footer.fila1.titulo') }}</strong>
        <div>
          <a href="https://www.facebook.com/SocialDoctorio-112502453742126" target="_blank"><i class="fab fa-facebook-square"></i></a>
          <a href="https://www.linkedin.com/company/socialdoctor" target="_blank"><i class="fab fa-linkedin"></i></a>
          <a href="https://www.instagram.com/socialdoctor_io/" target="_blank"><i class="fab fa-instagram-square"></i></a>
          <a href="https://www.twitter.com/@SocialDoctor_io" target="_blank"><i class="fab fa-twitter-square"></i></a>
          <a href="https://www.tiktok.com/@social_doctor_io" target="_blank"><img src="../assets/icon-tik-tok.png" class="tiktok-icon" /></a>
        </div>
      </div>
      <div class="w-100">
        <div class="mb-12">© Copyright 2020 Social Doctor</div>
        <div>{{ $t('footer.derechos') }}</div>
      </div>
    </div>
    <div class="legal-block">
      <div class="container">
        <a href="#/aviso-legal"><span>{{ $t('footer.legal.aviso') }}</span></a>
        <a href="#/politica-privacidad"><span>{{ $t('footer.legal.privacidad') }}</span></a>
        <a href="#/politica-cookies"><span>{{ $t('footer.legal.cookies') }}</span></a>
        <a href="#/tc-usuarios"><span>{{ $t('footer.legal.tcUsuarios') }}</span></a>
        <a href="#/tc-profesionales"><span>{{ $t('footer.legal.tcProfesionales') }}</span></a>
        <a href="https://ec.europa.eu/consumers/odr/main/?event=main.home.selfTest"><span>{{ $t('footer.legal.conflictos') }}</span></a>
        <a href="#/subvenciones"><span>{{ $t('footer.legal.subvenciones') }}</span></a>
      </div>
    </div>
    <Cookies />
  </div>
</template>

<script>
import Cookies from './cookies.vue'
export default {
  name: 'Footer',
  components: {
    Cookies
  },
  methods: {
    openLink (tipo) {
      if (tipo !== 'conflictos') {
        this.router.push(tipo)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.footer {
  position: relative;
  width: 100%;
  background: url(../assets/bg-footer.png) no-repeat center center;
  background-size: cover;
  font-size: 20px;
  color: #444D67;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  &:after {
    content: '';
    position: absolute;
    width: 100%;
    max-width: 882px;
    top: 0;
    margin: 0 auto;
    height: 2px;
    background: #eff1f7;
  }

  a {
    text-decoration: none;
    outline: none;
    color: #444D67;
  }

  .container {
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    padding-top: 90px;
    padding-bottom: 90px;

    > div {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      span, i {
        cursor: pointer;
      }

      i {
        font-size: 40px;
        margin-right: 15px;
      }

      .tiktok-icon {
        margin-bottom: -5px;
      }
    }
  }

  .legal-block {
    width: 100%;
    background: #444D67;
    color: #fff;
    font-size: 14px;

    a {
      color: #fff;
    }

    .container {
      padding-top: 20px;
      padding-bottom: 0px;
      display: flex;
      align-items: center;
      justify-content: center;

      a {
        margin-left: 40px;
        margin-bottom: 20px;

        &:first-child {
          margin-left: 0;
        }
      }
    }
  }
}

@media(max-width: 1200px) {
  .footer {
    font-size: 16px;

    .container > div i {
      font-size: 30px;
    }

    .container > div .tiktok-icon {
      width: 27px;
    }
  }
}

@media(max-width: 900px) {
  .footer {
    font-size: 15px;

    .container > div i {
      font-size: 28px;
      margin-right: 10px;
    }

    .container > div .tiktok-icon {
      width: 26px;
    }
  }
}

@media(max-width: 680px) {
  .footer {
    font-size: 15px;

    .container {
      flex-direction: column;
      padding-top: 50px;
      padding-bottom: 50px;

      .mb-50, .mb-70 {
        margin-bottom: 30px !important;
      }

      & > div,
      & > span {
        width: 100% !important;
        margin-top: 25px;
        margin-left: 0 !important;
        margin-right: 0 !important;

        &:first-child {
          margin-top: 0 !important;
        }
      }
    }

    .legal-block .container a {
      margin-left: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue